const deleteSlide = slideRef => {
  return slideRef
    .delete()
}

export default deleteSlide
